import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class ReportsMasterService {
  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }

  getAllReportMaster(): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + 'reportmaster').pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getReportMaster(id: number,isMaintenance: boolean = true): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `reportmaster/${id}?isMaintenance=${isMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  createReportMaster(reportmaster: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'reportmaster', reportmaster).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  updateReportMaster(reportmaster: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'reportmaster', reportmaster).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `reportmaster/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }


  authorise(id: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'reportmaster/authorise', id).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getFilteredReportMaster(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
    };

    return this.httpClient.post(this.baseApiUrl + 'reportmaster/reportmasterfilter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

}
